// Empty-state placeholder shown in the marketplace grid when filters
// leave nothing to render.
//
// Rendering approach: `MarketplaceGrid.children` short-circuits to a
// single `{extends: 'MarketplaceEmptyState'}` descriptor instead of the
// catalog array. Per smbls v3.14 (packages/element/src/create.js:1461-1463),
// a `children: fn` return value fully owns rendering — named siblings
// like `EmptyState:` inside the grid would be silently skipped. Using a
// single-item array with `MarketplaceEmptyState` as the child works.
//
// Spans the full grid width (4 columns on canvas + standalone layouts)
// so the message centers in the viewport rather than squeezing into one
// card slot.

export const MarketplaceEmptyState = {
  flow: 'y',
  align: 'center center',
  gap: 'Z',
  padding: 'C A',
  gridColumn: '1 / -1',
  textAlign: 'center',

  EmptyStateTitle: {
    tag: 'h4',
    text: (el) => {
      const host = el.call('marketplaceHostOf', el)
      if (host?.activePricing === 'installed') return 'Nothing installed yet'
      const q = (host?.query || '').trim()
      if (q) return `No matches for "${q}"`
      return 'No items match your filters'
    },
    fontSize: 'A',
    fontWeight: '600',
    color: 'title',
    margin: '0'
  },

  EmptyStateHint: {
    tag: 'p',
    text: (el) => {
      const host = el.call('marketplaceHostOf', el)
      if (host?.activePricing === 'installed') {
        return 'Install a library, template, or plugin to see it here. Integrations added via your organization show up automatically.'
      }
      return 'Try broadening your filters — pick "All" kinds, clear the category chip, or remove the search term.'
    },
    fontSize: 'Z',
    color: 'caption',
    margin: '0',
    maxWidth: 'J'
  }
}
